'use client'

import './ShowModalButton.scss'

import { useState } from 'react'

import { IBookingTime } from '@/src/entities/event/api/interfaces'
import CustomModal from '@/src/shared/ui/Modal/Modal'
import { FeedbackForm } from '@/src/widgets/FeedbackForm/ui/FeedbackForm'

export type IShowModalButton = {
  children: React.ReactNode
  landingId?: number | string | null
  locale: string
  dates: IBookingTime
}

const ShowModalButton = ({ children, landingId, locale, dates }: IShowModalButton) => {
  const [modalIsOpen, setModalState] = useState(false)

  function handleModalChange(val: boolean) {
    setModalState(val)
  }

  return (
    <>
      <button onClick={() => handleModalChange(true)} className="show-modal-button">
        {children}
      </button>

      <CustomModal isOpen={modalIsOpen} onChange={handleModalChange}>
        <FeedbackForm locale={locale} landingId={landingId} dates={dates} />
      </CustomModal>
    </>
  )
}

export default ShowModalButton
